import React, { useState, useMemo, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate('/admin/login');
  };

  return (
    <>
      <Wrap>
        <LeftBox></LeftBox>
        <RightBox>
          <Btn onClick={handleLogout}>로그아웃</Btn>
        </RightBox>
      </Wrap>
    </>
  );
};

export default Header;

const Wrap = styled.header`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  border-bottom: 1px solid #dbdbdb;
`;

const LeftBox = styled.div``;

const RightBox = styled.div``;

const Btn = styled.button`
  font-size: 14px;
  color: #777;
`;
